import React, { useState } from 'react';
import { Box, Button, Stack } from '@mui/material';
import { MapSyncProvider } from '../components/forecast_metrics-components/maps/map_syncro.js';
import { useForecastMetricsState } from '../hooks/useForecastMetricsState.js';
import LoadingBackdrop from '../components/common/LoadingBackdrop.js';
import ForecastMapView from './ForecastMapView';
import './styles/view-forecast_metrics.css';


function ForecastMetricsVisualization() {
  const [showMapView, setShowMapView] = useState(true);
  const forecastState = useForecastMetricsState();
  
  const {
    cqlSevere,
    cqlFecha,
    selectedModel,
    mapLeftLayer,
    mapRightLayer,
    issueTime,
    issueTimeOptions,
    backdropOpen,
    cqlFechaMin,
    cqlFechaMax,
    weekNumber,
    prettyModelName,
    metricsName,
    handleDateChange,
    handleModelClick,
    handleRiskClick,
    handleDateSelect,
    handleTimeSelect,
    handleBackdropOpen,
    handleBackdropClose,
    setIssueTimeOptions,
  } = forecastState;

  return (
    <MapSyncProvider>
      <div className="analytics-container">
        <ForecastMapView
          prettyModelName={prettyModelName}
          issueTime={issueTime}
          cqlSevere={cqlSevere}
          cqlFecha={cqlFecha}
          mapLeftLayer={mapLeftLayer}
          weekNumber={weekNumber}
          selectedTime={forecastState.selectedTime}
          mapRightLayer={mapRightLayer}
          selectedModel={selectedModel}
          metricsName={metricsName}
          cqlFechaMax={cqlFechaMax}
          cqlFechaMin={cqlFechaMin}
          issueTimeOptions={issueTimeOptions}
          handleDateChange={handleDateChange}
          handleModelClick={handleModelClick}
          handleRiskClick={handleRiskClick}
          handleDateSelect={handleDateSelect}
          handleTimeSelect={handleTimeSelect}
          handleBackdropOpen={handleBackdropOpen}
          handleBackdropClose={handleBackdropClose}
          setIssueTimeOptions={setIssueTimeOptions}
          showMapView={showMapView}
          setShowMapView={setShowMapView}
          forecastState={forecastState}
        />

        <LoadingBackdrop open={backdropOpen} />
      </div>
    </MapSyncProvider>
  );
}

export default ForecastMetricsVisualization;
